import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';
import { AppService } from '../../services/app.service';
import { AuthService } from '../../services/auth.service';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { SidenavComponent } from './sidenav/sidenav.component';

@Component({
  selector: 'app-core',
  standalone: true,
  imports: [
    ToolbarComponent,
    SidenavComponent
  ],
  templateUrl: './core.component.html',
  styleUrl: './core.component.scss'
})
export class CoreComponent implements OnInit {
  private readonly appService = inject(AppService);
  private readonly translate = inject(TranslateService);
  private readonly authService = inject(AuthService);


  ngOnInit(): void {
    this.appService.setTheme();
    this.authService.isSupervisor().subscribe();
    this.configureLanguage();
    this.appService.checkForUpdates().subscribe(
      sw => console.log(sw.type)
    );
  }


  private configureLanguage(): void {
    this.translate.setDefaultLang('pl-PL'); // fallback lang
    const lang = localStorage.getItem('language') || 'pl-PL'; // set polish as default 
    this.translate.use(lang)
      .pipe(
        first()
      ).subscribe();
  }
}
